/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_Trending_TinydeskInputs */

const en_header_trending_tinydesk = /** @type {(inputs: Header_Trending_TinydeskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your own desk-side concert`)
};

/**
* | output |
* | --- |
* | "Your own desk-side concert" |
*
* @param {Header_Trending_TinydeskInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const header_trending_tinydesk = /** @type {((inputs?: Header_Trending_TinydeskInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_Trending_TinydeskInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_header_trending_tinydesk(inputs)
});
export { header_trending_tinydesk as "header.trending.tinydesk" }